module.exports = "/_next/static/images/bradesco-19c11a0117b5321960fe35145b6ed4f1.svg";